<template>
    <div class="w-layout-grid content-3-col-grid" id="certificate-page">
        <div class="side-content">
        </div>

        <div class="middle-content middle-content-initial-state">

            <div class="course-top">
                <div class="course-name-block">
                    <h2 class="section-title">{{this.form.id  ? trans('course.add_certificates_edit') : trans('course.add_certificates_add')}}</h2>
                </div>
                <a class="btn" @click="showPreview">{{trans('course.add_certificates_preview_button')}}</a>
                <a v-if="this.form.id" class="btn ml-2" @click="downloadPreview">{{trans('course.add_certificates_download_pdf')}}</a>
            </div>

            <div v-if="success" class="mt-3 alert alert-success alert-dismissible fade show" role="alert">
               {{trans('course.add_certificates_success')}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
            </div>

            <div v-if="validationErrors" class="mt-3 alert alert-danger alert-dismissible fade show" role="alert">
                <p class="mb-0" v-for="(value) in validationErrors">{{ value }}</p>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <form method="POST" @submit.prevent="save" enctype="multipart/form-data">
                <div class="row">
                    <div class="col-10">
                        <div class="form-group">
                            <label class="col-form-label" for="name">{{trans('course.add_certificates_name')}}</label>
                            <input id="name" maxlength="255" type="text" v-model="form.name" class="form-control"  required>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label class="col-form-label" for="pages">{{trans('course.add_certificates_pages')}}</label>
                            <input id="pages" type="number" v-model="form.pages" class="form-control"  required>
                        </div>
                    </div>
                    <div class="col-12">
                        <h4>{{trans('course.add_certificates_alignment')}}</h4>
                        <div class="row">
                            <div class="col-3">
                                 <div class="form-group">
                                    <label class="col-form-label" for="alignment_top">{{trans('course.add_certificates_alignment_top')}}</label>
                                    <div class="input-group mb-3">
                                        <input required type="number" v-model="form.alignment_top" class="form-control" id="alignment_top">
                                        <div class="input-group-append">
                                            <span class="input-group-text">{{trans('course.add_certificates_pixels')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                 <div class="form-group">
                                    <label class="col-form-label" for="alignment_bottom">{{trans('course.add_certificates_alignment_bottom')}}</label>
                                    <div class="input-group mb-3">
                                        <input required type="number" v-model="form.alignment_bottom" class="form-control" id="alignment_bottom">
                                        <div class="input-group-append">
                                            <span class="input-group-text">{{trans('course.add_certificates_pixels')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                 <div class="form-group">
                                    <label class="col-form-label" for="alignment_right">{{trans('course.add_certificates_alignment_right')}}</label>
                                    <div class="input-group mb-3">
                                        <input required type="number" v-model="form.alignment_right" class="form-control" id="alignment_right">
                                        <div class="input-group-append">
                                            <span class="input-group-text">{{trans('course.add_certificates_pixels')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                 <div class="form-group">
                                    <label class="col-form-label" for="alignment_left">{{trans('course.add_certificates_alignment_left')}}</label>
                                    <div class="input-group mb-3">
                                        <input required type="number" v-model="form.alignment_left" class="form-control" id="alignment_left" >
                                        <div class="input-group-append">
                                            <span class="input-group-text">{{trans('course.add_certificates_pixels')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group" v-for="index in parseInt(form.pages)" >
                            <label class="col-form-label" for="name">{{trans('course.add_certificates_template')}}</label>
                            <ckeditor class="certificate-editor" :editor="editor" v-model="form.templates[index-1]" :config="editorConfig"></ckeditor>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label class="col-form-label" for="file-input">{{trans('course.add_certificates_background')}}</label>
                            <div>
                                <input @change="uploadImage($event)" type="file" accept="image/*" style="display:none" id="file-input" >
                                <button @click="uploadTrigger()" type="button" class="image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_from_pc') }}
                                </button>
                                <button @click="chooseFromLibrary(1, 'images', 'image')" type="button"
                                        class="image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_chose_from_library') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <img :src="form.background" class="certificate-background">
                    </div>
                </div>
                <button type="submit" class="btn btn-success float-right mt-3">
                    {{trans('course.add_certificates_save_button')}}
                </button>
            </form>
        </div>

        <div class="side-content right side-right-initial-state">
            <div v-if="!cid">
                <div class="section-title-wrap">
                    <h2 class="section-title">{{trans('course.add_certificates_shortcodes')}}</h2>
                </div>
                <div>{{trans('course.add_certificates_first_name')}}</div>
                <div>{{trans('course.add_certificates_last_name')}}</div>
                <div>{{trans('course.add_certificates_course_name')}}</div>
                <div>{{trans('course.add_certificates_author')}}</div>
            </div>
        </div>

        <div class="modal fade" id="previewCertificateModal" tabindex="-1" role="dialog"  aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="width: max-content" >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{trans('course.add_certificates_preview_title')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="width: 21cm;">
                        <div class="position-relative" v-for="index in parseInt(form.pages)">
                            <img class="w-100 img-responsive" :src="form.background">
                            <div v-bind:style="{top: form.alignment_top + 'px',bottom: form.alignment_bottom + 'px', right: form.alignment_right + 'px', left: form.alignment_left + 'px' }" v-html="form.templates[index-1]" class="certificate-wrap ck-content"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{trans('course.add_certificates_close_preview')}}</button>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="modal fade libraryModal" :id="'libraryModal'+unique" tabindex="-1" role="dialog"
        aria-labelledby="libraryModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'libraryModalTitle'+unique">
                            {{ trans('course.add_course_library') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 form-inline w-100 mb-3 justify-content-between">
                                <div class="mr-4">
                                    <label class="justify-content-start"
                                            for="name">{{ trans('course.add_course_library_filter_by_name') }}</label>
                                    <select @change="filterLibrary('name')" v-model="filterName" class="form-control"
                                            id="name" name="name">
                                        <option value="">{{ trans('course.add_course_library_select_option') }}</option>
                                        <option value="asc">{{ trans('course.add_course_library_ascending') }}</option>
                                        <option value="desc">{{ trans('course.add_course_library_descending') }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <label class="justify-content-start" for="size">Filter by Size</label>
                                    <select @change="filterLibrary('size')" class="form-control" id="size"
                                            v-model="filterSize">
                                        <option value="">{{ trans('course.add_course_library_select_option') }}</option>
                                        <option value="asc">{{ trans('course.add_course_library_ascending') }}</option>
                                        <option value="desc">{{ trans('course.add_course_library_descending') }}
                                        </option>
                                    </select>
                                </div>
                                <div class="ml-auto pt-3">
                                    <input @input="searchLibrary()" class="form-control mr-sm-2" type="search"
                                            v-model="filterSearch" value="" :placeholder="trans('forms.search')"
                                            aria-label="Search by filename">
                                    <button @click="filterLibrary('search')"
                                            class="btn btn-outline-success my-2 my-sm-0" type="button">
                                        {{ trans('course.add_course_library_search') }}
                                    </button>
                                </div>
                                <!--  <input type="hidden" name="view" value="{{$view}}">
                                    <input type="hidden" name="user" value="{{$userFilter}}"> -->
                            </div>
                            <div v-if="typeof library[0] != 'undefined'" class="col-12 col-sm-6 col-lg-6 col-xl-4" v-for="file in library">
                                <div class="card mb-3 pointer" @click="selectFile(file)">
                                    <!--  <a href="{{route('delete-file-library', ['file' => $file->id,'type' => $type, 'user'=>$userFilter])}}" class="library-delete delete-confirm">
                                            <i class="far fa-trash-alt"></i>
                                        </a> -->
                                    <img v-if="file.type=='images'" class="card-img-top img-fluid img-library" :src="'/library/file/'+file.hash">
                                    <div v-if="file.type=='videos'" class="pointer text-center preview-file">
                                        <i class="fas fa-film library-icon"></i>
                                    </div>
                                    <div v-if="file.type=='audio'" class="pointer text-center preview-file">
                                        <i class="fas fa-file-audio"></i>
                                    </div>
                                    <div v-if="file.type=='documents'" class="pointer text-center preview-file">
                                        <i class="far fa-file"></i>
                                    </div>

                                </div>
                                <div class="card-body mt-0">
                                    <label class="card-title">
                                        {{ file.path|fileNameFromUrl }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 text-center" v-if="showLoadMore">
                                <button type="button"
                                        @click='chooseFromLibrary(libraryIdx, libraryType, libraryType.replace("s", ""), libraryPage)'
                                        class="btn btn-primary">{{ trans('course.add_course_library_load_more') }}
                                </button>
                            </div>
                            <div v-if="typeof library[0] == 'undefined'" class=" col-12 text-center mt-4 w-100">
                                <h3>{{ trans('course.add_course_library_search') }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            {{ trans('course.add_course_library_close_modal') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomEditor from "../includes/ck-editor/ck-editor-custom";
    import UploadAdapter from "./UploadAdapter";

    export default {
        name: "certificate",
        components: {
        },
        computed: {
            validationErrors(){
                if (this.saveErrors && Object.keys(this.saveErrors).length !== 0) {
                    let errors = Object.values(this.saveErrors);
                    errors = errors.flat();
                    return errors;
                }
                return null;
            }
        },
        created() {
            const url = window.location.pathname;
            let id = parseInt(url.substring(url.lastIndexOf('/') + 1));
            if (id && Number.isInteger(id) && !this.cid) {
                this.form.id = id;
                this.getCertificate();
            }
        },
        data: function() {
            return {
                success: false,
                wrapClass: (this.cid ? 'col-md-12' : 'col-md-8'),
                unique: Math.floor(Math.random() * (1500000000 + 1)),
                library: [],
                libraryPage: 1,
                libraryIdx: null,
                libraryType: '',
                libraryCol: '',
                filterName: '',
                filterSize: '',
                filterSearch: '',
                showLoadMore: true,
                form: {
                    id: null,
                    name: '',
                    pages: 1,
                    template: '',
                    templates: [],
                    alignment_top: '',
                    alignment_bottom: '',
                    alignment_right: '',
                    alignment_left: '',
                    image: '',
                    background: '/images/cerrificate.jpg',
                },
                editor: CustomEditor,
                editorConfig: {
                    extraPlugins: [this.uploader],
                    link: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'http://',
                    },
                },
                saveErrors: null,
            }
        },
        props: {
           cid: Number,
        },
        mounted(){
        },
        methods: {
            uploader(editor) {
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader );
                };
            },
            getCertificate : function(deleteLeson=false) {
                if (!this.form.id) {
                    return;
                }
                this.loader = true;
                let $end = '/api/get-certificate/'+this.form.id;
                let self = this;

                axios.get($end).then(function (response) {
                    response = response.data;
                    self.form.name = response.name;
                    self.form.pages = response.pages;
                    self.form.template = response.template;
                    self.form.templates = response.templates ? JSON.parse(response.templates) : [];
                    self.form.alignment_top = response.alignment_top;
                    self.form.alignment_bottom = response.alignment_bottom;
                    self.form.alignment_right = response.alignment_right;
                    self.form.alignment_left = response.alignment_left;

                    self.form.background = response.background ? '/library/file/'+response.background.hash : '/images/cerrificate.jpg';
                    self.loader = false;
                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            save: function() {
                let self = this;
                let $end = '/api/save-certificate';

                axios.post($end, this.form).then(response  => {
                    this.success = true;
                    this.form.id = response.data.id;
                    this.getCertificate();
                    if (this.cid) {
                        this.$emit('get-certificates-method',response.data)
                    } else {
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    }
                }).catch(error => {
                    if (error.response.status === 422){
                        this.saveErrors = error.response.data.errors;
                    }
                    this.$data.loader = false;
                });
            },
            showPreview: function() {
                $('#previewCertificateModal').modal('show');
            },
            downloadPreview: function() {
                let self = this
                let $end = '/api/download-certificate-preview';
                axios({url: $end, method: 'POST', data: this.form, responseType: 'blob'}).then(response  => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.form.name +'.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    fileLink.remove();
                }).catch(err => {
                    this.$data.loader = false;
                });
            },
            uploadTrigger(id, type = false) {
                $('#file-input').trigger('click');
            },
            uploadImage(e, library=false) {
                let $end = '/api/certificate-upload-background';
                let data;
                if(!library){
                    data = new FormData();
                    data.append('id', this.form.id);
                    data.append('image', e.target.files[0]);
                    this.form.image = e.target.files[0];
                } else {
                    data = {
                        id: this.form.id,
                        library: true,
                        image: library
                    };

                }

                axios.post($end, data).then(response  => {
                    this.form.id = response.data.certificate.id;
                    if(!library){
                        this.form.background =  '/library/file/'+response.data.image;
                    }
                }).catch(error => {
                    if (error.response.status === 422){
                        this.saveErrors = error.response.data.errors;
                    }
                    this.$data.loader = false;
                });
            },
            chooseFromLibrary: function (id, type, column, page = false) {
                let $end = '/api/library/' + type + '/true';
                let self = this;
                self.showLoadMore = true;

                this.libraryIdx = id;
                this.libraryType = type;
                this.libraryCol = column;

                let params = {};
                if (this.filterName) {
                    params.name = this.filterName;
                }
                if (this.filterSize) {
                    params.size = this.filterSize;
                }
                if (this.filterSearch) {
                    params.search = this.filterSearch;
                }

                if (page) {
                    params.page = page + 1;
                }

                this.currentLibraryId = id;
                this.currentLibraryColumn = column;
                axios.get($end, {
                    params: params
                }).then(function (res) {
                    let response = res.data;
                    self.libraryPage = response.files.current_page;

                    if (self.libraryPage == response.files.last_page) {
                        self.showLoadMore = false;
                    }

                    if (page) {
                        self.library = [...self.library, ...response.files.data];
                    } else {
                        self.library = response.files.data;
                    }
                    $('#libraryModal' + self.unique).modal('show');

                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            },
            selectFile: function (file) {
                this.uploadImage(false,file.id);
                $('#libraryModal' + this.unique).modal('hide');
                this.form.background =  '/library/file/'+file.hash;
            },
        },

    }
</script>
